(() => {
  if (window.runcamDownloadModalInitialized) return;
  window.runcamDownloadModalInitialized = true;

  let activeModal = null;
  let returnFocus = null;
  let previousOverflow = '';

  const getFocusable = (modal) => Array.from(modal.querySelectorAll(
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  )).filter((element) => !element.hidden && element.offsetParent !== null);

  const closeModal = () => {
    if (!activeModal) return;
    activeModal.hidden = true;
    document.body.style.overflow = previousOverflow;
    activeModal = null;
    if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    returnFocus = null;
  };

  const openModal = (trigger) => {
    const modalId = trigger.dataset.runcamDownloadOpen || trigger.dataset.modalOpen || '';
    const modal = document.getElementById(modalId);
    if (!modal?.hasAttribute('data-runcam-download-modal')) return false;

    const type = trigger.dataset.downloadType;
    const panels = Array.from(modal.querySelectorAll('[data-download-panel]'));
    const target = panels.find((panel) => panel.dataset.downloadPanel === type);
    const categoryMode = modal.classList.contains('runcam-download-modal--categories');
    if (categoryMode && !target) return false;
    if (activeModal) closeModal();

    if (categoryMode) {
      modal.dataset.downloadType = type;
      for (const panel of panels) panel.hidden = panel !== target;
    }
    const label = modal.querySelector('[data-download-label]');
    if (label) label.textContent = trigger.dataset.downloadLabel || '';

    returnFocus = trigger;
    activeModal = modal;
    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    modal.hidden = false;

    const body = modal.querySelector('.runcam-download-modal__body');
    if (categoryMode && body) body.scrollTop = 0;
    if (!categoryMode && target) {
      target.scrollIntoView({ block: 'nearest' });
      target.focus();
    } else {
      modal.querySelector('button[data-runcam-download-close]')?.focus({ preventScroll: true });
    }
    return true;
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-runcam-download-open], [data-modal-open]');
    if (trigger && openModal(trigger)) {
      event.preventDefault();
      return;
    }

    if (event.target.closest('[data-runcam-download-close]')?.closest('[data-runcam-download-modal]') === activeModal) {
      closeModal();
      return;
    }

    const firmwareToggle = event.target.closest('[data-runcam-firmware-toggle]');
    if (firmwareToggle && firmwareToggle.closest('[data-runcam-download-modal]') === activeModal) {
      const item = firmwareToggle.closest('.runcam-download-modal__firmware-item');
      const list = item?.closest('.runcam-download-modal__firmware-list');
      if (!item || !list) return;

      const shouldOpen = !item.classList.contains('is-open');
      list.querySelectorAll('.runcam-download-modal__firmware-item').forEach((candidate) => {
        const isOpen = candidate === item && shouldOpen;
        candidate.classList.toggle('is-open', isOpen);
        candidate
          .querySelector('.runcam-download-modal__firmware-toggle')
          ?.setAttribute('aria-expanded', String(isOpen));
      });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (!activeModal) return;
    if (event.key === 'Escape') {
      closeModal();
      return;
    }
    if (event.key !== 'Tab') return;

    const focusable = getFocusable(activeModal);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!focusable.includes(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target instanceof Element && activeModal && event.target.contains(activeModal)) closeModal();
  });
})();
